import LeftBarPageRegisterLogin from "./LeftBarPageRegisterLogin";

import PageWellcome from "../alert/PageWellcome";

const LoginPage2 = () => {
  return (
    <div id="login" className="flex flex-col lg:flex-row h-screen w-full overflow-hidden">
      <LeftBarPageRegisterLogin
        children={
          <>
            <PageWellcome status={true} />
          </>
        }
      />
      <div className="hidden lg:flex h-full w-full lg:w-[40%] items-center justify-center px-4 py-10">
        <PageWellcome status={false} />
      </div>
    </div>
  );
};

export default LoginPage2;
